import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import React, { memo } from 'react';

import SectionNewsletter from '../../containers/LandingPage/SectionNewsletter';
import { neutral } from '../../styles/mui/colors';

const modalStyles = {
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    overflow: 'scroll',
    p: 4,
    backgroundColor: neutral[50],
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
};

const NewsLetterModalContentComponent = ({ isOpen, onClose }) => {
  return (
    <Modal
      aria-describedby="newsletter-modal-description"
      aria-labelledby="newsletter-modal-title"
      onClose={onClose}
      open={isOpen}
    >
      <Box sx={modalStyles.wrapper}>
        <Box sx={modalStyles.iconContainer}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <SectionNewsletter googleCaptchaElementId="mobileMenuElementId" onClose={onClose} />
      </Box>
    </Modal>
  );
};

NewsLetterModalContentComponent.displayName = 'NewsLetterModalContent';

export const NewsLetterModal = memo(NewsLetterModalContentComponent);
